var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c(
            "el-breadcrumb",
            [
              _c("el-breadcrumb-item", [_vm._v("业务管理")]),
              _c("el-breadcrumb-item", [_vm._v("工单管理")]),
              _c("el-breadcrumb-item", [_vm._v("Dcops工单")]),
              _c("el-breadcrumb-item", [_vm._v("服务器搬迁")])
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v("搜索条件")]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "search-container" },
          [
            _c(
              "el-form",
              {
                staticClass: "search-form",
                attrs: {
                  inline: true,
                  model: _vm.searchForm,
                  "label-width": "100px"
                }
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "建单时间" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "daterange",
                                "range-separator": "-",
                                "start-placeholder": "开始日期",
                                "end-placeholder": "结束日期",
                                "value-format": "yyyy-MM-dd"
                              },
                              on: { change: _vm.handleDateChange },
                              model: {
                                value: _vm.searchForm.create_time,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "create_time", $$v)
                                },
                                expression: "searchForm.create_time"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "超时时间" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "daterange",
                                "range-separator": "-",
                                "start-placeholder": "开始日期",
                                "end-placeholder": "结束日期",
                                "value-format": "yyyy-MM-dd"
                              },
                              on: { change: _vm.handleOlaTimeChange },
                              model: {
                                value: _vm.searchForm.olaTime,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "olaTime", $$v)
                                },
                                expression: "searchForm.olaTime"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "工单ID" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入工单ID" },
                              model: {
                                value: _vm.searchForm.TicketId,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "TicketId", $$v)
                                },
                                expression: "searchForm.TicketId"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "时效" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  clearable: "",
                                  placeholder: "请选择时效"
                                },
                                model: {
                                  value: _vm.searchForm.rd_olaTime,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "rd_olaTime", $$v)
                                  },
                                  expression: "searchForm.rd_olaTime"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "预超时", value: "1" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "超时-进行中", value: "2" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "超时-完成", value: "3" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "区域-园区" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { clearable: "", placeholder: "请选择" },
                                on: { focus: _vm.handleSelectFocus },
                                model: {
                                  value: _vm.searchForm.Campus,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "Campus", $$v)
                                  },
                                  expression: "searchForm.Campus"
                                }
                              },
                              _vm._l(_vm.campusOptions, function(item) {
                                return _c("el-option", {
                                  key: item,
                                  attrs: { label: item, value: item }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "场景" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  clearable: "",
                                  placeholder: "请选择场景"
                                },
                                model: {
                                  value: _vm.searchForm.Scene,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "Scene", $$v)
                                  },
                                  expression: "searchForm.Scene"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "搬入", value: "搬入" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "搬出", value: "搬出" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "状态" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  clearable: "",
                                  placeholder: "请选择状态"
                                },
                                model: {
                                  value: _vm.searchForm.state,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "state", $$v)
                                  },
                                  expression: "searchForm.state"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "完成", value: "完成" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "进行中", value: "进行中" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "驳回", value: "驳回" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c(
                        "div",
                        { staticClass: "search-button" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.handleSearch }
                            },
                            [_vm._v("点击查询")]
                          ),
                          _c("el-button", { on: { click: _vm.handleReset } }, [
                            _vm._v("重置")
                          ]),
                          _c(
                            "el-button",
                            { on: { click: _vm.debouncedExport } },
                            [_vm._v(_vm._s(_vm.exportButtonText))]
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "title-en" }, [_vm._v("服务器搬迁列表")]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "table-container" },
          [
            _c(
              "div",
              { staticClass: "button-container" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "success", plain: "" },
                    on: { click: _vm.UpdateServerMoveListBtn }
                  },
                  [_vm._v("更新服务器列表")]
                ),
                _c("el-button", { on: { click: _vm.openColumnsDialog } }, [
                  _vm._v("表头设置")
                ])
              ],
              1
            ),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                ref: "table",
                attrs: { data: _vm.showData, border: "", stripe: "" },
                on: { "selection-change": _vm.handleSelectionChange }
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "55", align: "center" }
                }),
                _vm._l(_vm.visibleColumns, function(column, index) {
                  return _c("el-table-column", {
                    key: index,
                    attrs: {
                      prop: column.prop,
                      label: column.label,
                      width: column.width,
                      align: column.align,
                      fixed: column.fixed
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              column.prop === "TaskList"
                                ? _c("div", { staticClass: "tasklist-cell" }, [
                                    _vm.normalizedTaskList(
                                      scope.row.TaskList,
                                      scope.row.Scene
                                    ).length
                                      ? _c(
                                          "table",
                                          { staticClass: "tasklist-mini" },
                                          [
                                            _c("thead", [
                                              _c("tr", [
                                                _c(
                                                  "th",
                                                  {
                                                    staticStyle: {
                                                      width: "40px"
                                                    }
                                                  },
                                                  [_vm._v("任务")]
                                                ),
                                                _c(
                                                  "th",
                                                  {
                                                    staticStyle: {
                                                      width: "90px"
                                                    }
                                                  },
                                                  [_vm._v("时间")]
                                                ),
                                                _c(
                                                  "th",
                                                  {
                                                    staticStyle: {
                                                      width: "120px"
                                                    }
                                                  },
                                                  [_vm._v("接单人")]
                                                ),
                                                _c(
                                                  "th",
                                                  {
                                                    staticStyle: {
                                                      width: "120px"
                                                    }
                                                  },
                                                  [_vm._v("结单人")]
                                                ),
                                                _c(
                                                  "th",
                                                  {
                                                    staticStyle: {
                                                      width: "80px"
                                                    }
                                                  },
                                                  [_vm._v("状态")]
                                                )
                                              ])
                                            ]),
                                            _c(
                                              "tbody",
                                              _vm._l(
                                                _vm.normalizedTaskList(
                                                  scope.row.TaskList,
                                                  scope.row.Scene
                                                ),
                                                function(t, tIndex) {
                                                  return _c(
                                                    "tr",
                                                    { key: tIndex },
                                                    [
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "tasklist-step"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              t.label ||
                                                                t.key ||
                                                                "-"
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "tasklist-time"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "tasklist-time-wrap"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "tasklist-time-row"
                                                                },
                                                                [
                                                                  _c("span", {
                                                                    staticClass:
                                                                      "tasklist-time-dot"
                                                                  }),
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.formatTaskTime(
                                                                          t.beginTime
                                                                        )
                                                                      )
                                                                    )
                                                                  ])
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "tasklist-time-row"
                                                                },
                                                                [
                                                                  _c("span", {
                                                                    staticClass:
                                                                      "tasklist-time-line"
                                                                  }),
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.formatTaskTime(
                                                                          t.endTime
                                                                        )
                                                                      )
                                                                    )
                                                                  ])
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "tasklist-operator"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              t.operator || "-"
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "tasklist-operator"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              t.realOperator ||
                                                                "-"
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "tasklist-status"
                                                        },
                                                        [
                                                          _c(
                                                            "el-tooltip",
                                                            {
                                                              attrs: {
                                                                content:
                                                                  t.status ||
                                                                  "未知",
                                                                placement: "top"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "tasklist-status-wrap"
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    class: _vm.taskStatusIcon(
                                                                      t.status
                                                                    )
                                                                  }),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "tasklist-status-text"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          t.status ||
                                                                            "-"
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          ]
                                        )
                                      : _c(
                                          "span",
                                          { staticClass: "tasklist-empty" },
                                          [_vm._v("-")]
                                        )
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatCell(scope.row, column.prop)
                                      )
                                    )
                                  ])
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                })
              ],
              2
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "选择月份范围",
                  visible: _vm.monthSelectDialogVisible,
                  "append-to-body": true,
                  width: "700px",
                  "close-on-click-modal": false,
                  "custom-class": "month-select-dialog",
                  "modal-append-to-body": false,
                  "destroy-on-close": true
                },
                on: {
                  "update:visible": function($event) {
                    _vm.monthSelectDialogVisible = $event
                  }
                }
              },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      model: _vm.monthSelectForm,
                      "label-width": "100px"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "开始月份" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "month",
                            placeholder: "选择开始月份",
                            format: "yyyy-MM",
                            "value-format": "yyyy-MM"
                          },
                          model: {
                            value: _vm.monthSelectForm.startMonth,
                            callback: function($$v) {
                              _vm.$set(_vm.monthSelectForm, "startMonth", $$v)
                            },
                            expression: "monthSelectForm.startMonth"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "结束月份" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "month",
                            placeholder: "选择结束月份",
                            format: "yyyy-MM",
                            "value-format": "yyyy-MM"
                          },
                          model: {
                            value: _vm.monthSelectForm.endMonth,
                            callback: function($$v) {
                              _vm.$set(_vm.monthSelectForm, "endMonth", $$v)
                            },
                            expression: "monthSelectForm.endMonth"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function($event) {
                            _vm.monthSelectDialogVisible = false
                          }
                        }
                      },
                      [_vm._v("取消")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.confirmMonthSelect }
                      },
                      [_vm._v("确定")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "设置显示项",
                  visible: _vm.showColumnsDialog,
                  "append-to-body": true,
                  width: "400px",
                  "close-on-click-modal": false,
                  "custom-class": "columns-dialog",
                  "modal-append-to-body": false,
                  "destroy-on-close": true
                },
                on: {
                  "update:visible": function($event) {
                    _vm.showColumnsDialog = $event
                  }
                }
              },
              [
                _c(
                  "el-checkbox-group",
                  {
                    staticClass: "checkbox-group",
                    model: {
                      value: _vm.selectedColumns,
                      callback: function($$v) {
                        _vm.selectedColumns = $$v
                      },
                      expression: "selectedColumns"
                    }
                  },
                  _vm._l(_vm.columns, function(column) {
                    return _c(
                      "el-checkbox",
                      {
                        key: column.prop,
                        staticClass: "checkbox-item",
                        attrs: { label: column.prop }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(column.label) +
                            "\n          "
                        )
                      ]
                    )
                  }),
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.selectAllColumns }
                      },
                      [_vm._v("全选")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.restoreDefaultColumns }
                      },
                      [_vm._v("恢复默认")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: { click: _vm.saveColumnsDialog }
                      },
                      [_vm._v("保存")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-container" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage,
                    "page-sizes": [10, 20, 30, 50],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.total
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }